import { apiSlice } from './api';
import { Env, ResponseBody } from '../types/common';

export const commonApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEnv: builder.query<Env, void>({
      query: () => ({
        url: 'common/env/init',
      }),
      transformResponse: (res: ResponseBody) => res.data,
    }),
    getSortBy: builder.query({
      query: (tag) => `common/sortby/${tag}`,
      transformResponse: (res: ResponseBody) => res.data,
    }),
    countHits: builder.mutation({
      query: (projectId) => ({
        url: `common/access/${projectId}`,
        method: 'POST',
      }),
      invalidatesTags: ['Search'],
    }),
    getPages: builder.query({
      query: (projectId) => `common/page/init/${projectId}`,
      transformResponse: (res: ResponseBody) => res.data,
    }),
    validateProfanity: builder.mutation({
      query: (words) => ({
        url: 'common/filter/profanity/validate',
        method: 'POST',
        body: { data: { words } },
      }),
      transformResponse: (res: any) => res.data.isValidate,
    }),
    setUploaderType: builder.mutation({
      query: (uploaderType: number) => ({
        url: `common/resources/upload/type?uploaderType=${uploaderType}`,
        method: 'POST',
      }),
      transformResponse: (res: any) => res.data,
    }),
  }),
});

export const {
  useGetEnvQuery,
  useGetSortByQuery,
  useCountHitsMutation,
  useGetPagesQuery,
  useValidateProfanityMutation,
  useSetUploaderTypeMutation,
} = commonApiSlice;
